/**
 * Positions of scroll that can be done to bring and element in view.
 */
export var ScrollInViewType;
(function (ScrollInViewType) {
    ScrollInViewType["TOP"] = "top";
    ScrollInViewType["BOTTOM"] = "bottom";
    ScrollInViewType["ANY"] = "any";
    ScrollInViewType["CENTER"] = "center";
})(ScrollInViewType || (ScrollInViewType = {}));
export var ScrollInViewBehaviourType;
(function (ScrollInViewBehaviourType) {
    ScrollInViewBehaviourType["AUTO"] = "auto";
    ScrollInViewBehaviourType["SMOOTH"] = "smooth";
})(ScrollInViewBehaviourType || (ScrollInViewBehaviourType = {}));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const scrollBehaviour = window.CY_DISABLE_SMOOTH_SCROLL
    ? ScrollInViewBehaviourType.AUTO
    : ScrollInViewBehaviourType.SMOOTH;
const scrollInView = {
    isInView(element, type = ScrollInViewType.TOP, customTop) {
        const position = element?.getBoundingClientRect();
        const windowHeight = window.innerHeight || 0;
        const yTop = position.top;
        const yBottom = position.top + position.height;
        if (type === ScrollInViewType.ANY) {
            return ((yTop < (customTop || 0) && yBottom > windowHeight) ||
                (yTop > (customTop || 0) && yTop < windowHeight) ||
                (yBottom > 0 && yBottom < windowHeight));
        }
        else if (type === ScrollInViewType.TOP) {
            return yTop > (customTop || 0) && yTop < windowHeight;
        }
        else if (type === ScrollInViewType.BOTTOM) {
            return yBottom > 0 && yBottom < windowHeight;
        }
    },
    scrollInView(element, type = ScrollInViewType.TOP, scrollInViewType) {
        const scrollInViewBehaviour = scrollInViewType ?? scrollBehaviour;
        if (element.scrollIntoView) {
            if (type === ScrollInViewType.ANY) {
                element.scrollIntoView({
                    block: 'nearest',
                    behavior: scrollInViewBehaviour,
                });
            }
            else if (type === ScrollInViewType.TOP) {
                element.scrollIntoView({
                    block: 'start',
                    behavior: scrollInViewBehaviour,
                });
            }
            else if (type === ScrollInViewType.BOTTOM) {
                element.scrollIntoView({
                    block: 'end',
                    behavior: scrollInViewBehaviour,
                });
            }
            else if (type === ScrollInViewType.CENTER) {
                element.scrollIntoView({
                    block: ScrollInViewType.CENTER,
                    behavior: scrollInViewBehaviour,
                });
            }
        }
        else {
            const position = element.getBoundingClientRect();
            const windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            const yTop = position.top;
            const yBottom = position.top + position.height;
            const padding = 10;
            if (type === ScrollInViewType.ANY) {
                document.documentElement.scrollTop -= -yTop + padding;
            }
            else if (type === ScrollInViewType.TOP) {
                document.documentElement.scrollTop -= -yTop + padding;
            }
            else if (type === ScrollInViewType.BOTTOM) {
                document.documentElement.scrollTop += yBottom + padding - windowHeight;
            }
        }
    },
};
export default scrollInView;
//# sourceMappingURL=scrollInView.js.map